import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router';
import Loader from 'components/technical/Loader/Loader.tsx';

export interface IBKRCallbackState {
  token?: string;
  verifier?: string;
  action: 'connect';
}

const IbkrCallback = (): ReactElement => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const oauth_token = searchParams.get('oauth_token') ?? undefined;
  const oauth_verifier = searchParams.get('oauth_verifier') ?? undefined;

  return (
    <>
      <Loader />
      <Navigate
        to="/app/management/account/non-crypto"
        replace
        state={{ verifier: oauth_verifier, token: oauth_token, action: 'connect' } satisfies IBKRCallbackState}
      />
    </>
  );
};

export default IbkrCallback;
